import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const supSchoolListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fsup-school.jpg?alt=media&token=2f0ff468-b4f9-4601-a575-3760e49af897",
  title: "SUP School",
  subtitle: "Stand up for Great Software.",
  page: WildNavigationType.SUPSCHOOLS,
}